import React, {useState} from 'react'
import SpielDetailsDialog from "./SpielDetailsDialog";
import {Spiel} from "./SchweizerRundenBereich";
import {vorhanden} from "./statistikWerte";

const GUELTIGE_TYPEN = ["EZ", "DP", "TG"];

/**
 * Spiele eines Ligaspieltags im neuen Design (nur lesen): oben der Gesamtstand Heim : Gast,
 * darunter je Phase eine Karte mit den freigegebenen (gesperrten) Spielen.
 * Die alte Ansicht verwendet weiterhin PublicLigaspieltagGamesTab.
 */
export default function LigaspieltagSpieleBereich({tournament, liveGames, boardGames}) {

    const [markierterSpieler, setMarkierterSpieler] = useState(undefined);
    const [statistikGame, setStatistikGame] = useState(undefined);

    const games = tournament.tournamentLeagueGameEntities || [];

    const spielerName = (playerId) => {
        const player = tournament.tournamentPlayerEntities.find(tmp => tmp.id === playerId);
        return player ? player.name : "Spielername nicht gefunden.";
    }

    const getGesamtstand = () => {
        let heim = 0;
        let gast = 0;
        let gespielt = 0;
        for (const game of games) {
            if (vorhanden(game.anzahlPlayer1) && vorhanden(game.anzahlPlayer2)) {
                gespielt++;
                if (game.anzahlPlayer1 > game.anzahlPlayer2) {
                    heim++;
                } else if (game.anzahlPlayer1 < game.anzahlPlayer2) {
                    gast++;
                }
            }
        }
        return {heim, gast, gespielt};
    }

    const getPhasen = () => {
        const hoechstePhase = games.reduce((max, game) => Math.max(max, game.bereich || 1), 1);
        const phasen = [];
        for (let bereich = 1; bereich <= hoechstePhase; bereich++) {
            const spiele = games.filter(game => game.bereich === bereich && game.gesperrt);
            if (spiele.length > 0) {
                phasen.push({bereich, spiele});
            }
        }
        return phasen;
    }

    if (games.length === 0) {
        return <div className="dhpt-statistik">
            <p className="dhpt-hinweis">Aktuell keine Spiele vorhanden.</p>
        </div>
    }

    const stand = getGesamtstand();
    const phasen = getPhasen();

    const kennzahl = (wert, bezeichnung) => <div className="dhpt-kennzahl"><b>{wert}</b><small>{bezeichnung}</small></div>;

    return <div className="dhpt-statistik dhpt-ls">
        <div className="dhpt-kennzahlen">
            {kennzahl(stand.heim + " : " + stand.gast, "Ergebnis Heim : Gast")}
            {kennzahl(stand.gespielt + " / " + games.length, "Spiele beendet")}
        </div>
        {phasen.length === 0
            ? <p className="dhpt-hinweis">Es wurden noch keine Spiele freigegeben.</p>
            : <div className="dhpt-ls-phasen">
                {phasen.map(phase => <section key={phase.bereich} className="dhpt-karte">
                    <h3 className="dhpt-karte-titel">
                        <span>Phase {phase.bereich}</span>
                        <span className="dhpt-karte-zusatz">{phase.spiele.length} {phase.spiele.length === 1 ? "Spiel" : "Spiele"}</span>
                    </h3>
                    <div className="dhpt-sr-spiele">
                        {phase.spiele.map(game => GUELTIGE_TYPEN.includes(game.type)
                            ? <Spiel key={game.id} spiel={ligaSpiel(game)} statistikNurMitScoring={true} tournament={tournament}
                                     spielerName={spielerName} boardGames={boardGames} liveGames={liveGames}
                                     markierterSpieler={markierterSpieler} onMarkiere={setMarkierterSpieler} onStatistik={setStatistikGame}/>
                            : <p key={game.id} className="dhpt-hinweis">Fehlerhafter Gametype, bitte Admin verständigen. LeagueGameId: {game.id}</p>
                        )}
                    </div>
                </section>)}
            </div>
        }
        {statistikGame !== undefined &&
            <SpielDetailsDialog tournamentId={tournament.id} tournamentGameId={statistikGame.id} ergebnisVomScorer={statistikGame.ergebnisVomScorer === true}
                                 onClose={() => setStatistikGame(undefined)}/>
        }
    </div>
}

// Ligaspiel auf die gemeinsame Form der Spiel-Komponente bringen
function ligaSpiel(game) {
    return {
        id: game.id, spieler1: game.player1Id, spieler2: game.player2Id, anzahl1: game.anzahlPlayer1, anzahl2: game.anzahlPlayer2,
        ohneGegner: false, ergebnisVomScorer: game.ergebnisVomScorer,
        titel: "Spiel " + game.counter + (game.type === "DP" ? " · Doppel" : game.type === "TG" ? " · Team-Game" : ""),
    };
}
